function WorkspaceModalController() {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.mode = ctrl.resolve.mode;
    if (ctrl.resolve.workspace) {
      ctrl.workspaceObject = ctrl.resolve.workspace;
    } else {
      ctrl.workspaceObject = { };
    }
  };

  ctrl.confirmCreation = event => {
    // TODO: IF START DATE GENERATED FRONTEND
    // ctrl.workspaceObject.start_date = Date.now();
    ctrl.close({ $value: { workspace: event.workspace, mode: ctrl.mode } });
  };

  ctrl.setValidity = event => {
    ctrl.close({ $value: { mode: ctrl.mode, id: event.id, start: event.startDate, end: event.endDate } });
  };

  ctrl.setDeployable = () => {
    ctrl.close({ $value: { workspace: ctrl.workspaceObject, mode: ctrl.mode } });
  };

  ctrl.onDelete = event => {
    ctrl.close({ $value: { id: ctrl.workspaceObject.id, mode: ctrl.mode } });
  };

  ctrl.cancel = () => {
    ctrl.dismiss({ $value: 'cancel' });
  };
}

angular
  .module('pis-tool.module')
  .controller('WorkspaceModalController', WorkspaceModalController);
